export default {
  searchInput: {
    position: 'fixed',
    top: 15,
    left: 220,
    width: 550,
    zIndex: 10000
  },
  iconStyle: {
    paddingTop: 10,
    paddingLeft: 0,
    paddingRight: 5
  },
  searchResult : {
    margin: '0 0 20px 0',
    background: '#fff',
    padding: 10,
    borderRadius: 10,
    cursor: 'pointer'
  },
  searchResultHeader: {
    position: 'relative',
    height: 30    
  },
  searchResultHeaderH3: {
    position: 'absolute',
    left: 30,
  }
}


// WEBPACK FOOTER //
// ./src/search/search.css.js